import React from "react";
import Header from "../components/Header/Header.jsx";
import HeaderLinks from "../components/Header/HeaderLinks.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import componentsStyle from "../assets/jss/material-kit-react/views/components.jsx";
import Footer from "../components/Footer/Footer.jsx";

class Layout extends React.Component {

  render() {
    const { classes, language, color, match, ...rest } = this.props;
    return (
      <div>
        <Header
          brand={language.title}
          rightLinks={<HeaderLinks language={language} match={match} {...rest} />}
          fixed
          color={color}
          changeColorOnScroll={{
            height: 400,
            color: "white"
          }}
          {...rest}
          match={match}
        />

        {this.props.children}

        <Footer {...language} match={match} {...rest} />
      </div>
    );
  }
}

export default withStyles(componentsStyle)(Layout);



// WEBPACK FOOTER //
// ./src/Layout/Layout.jsx